import React from 'react';
import { featureFlags } from 'lib/rollout';
import Rox from 'rox-browser';
import styles from './dev-tools.css';

class DevToolsWrapper extends React.Component {
  render() {
    return featureFlags.showDevTools.isEnabled() ? (
      <div className={styles.devToolsWrapper}>
        <div className={styles.devToolsButtons}>
          <button
            id='dev-tools-feature-flags'
            className={styles.devToolBtn}
            onClick={() => Rox.showOverrides()}
          >
            Feature Flags
          </button>
        </div>
      </div>
    ) : null;
  }
}

export default DevToolsWrapper;
